import client from '../../client'

export interface Params {
  code?: string
  code2?: string
  shiryouType?: string
  keitou?: string
  prefecture?: string
  sno?: string
  sname?: string
}

export interface Response {
  resultList: {
    [key: string /** 学校ID+請求コード e.g. 'D100001_D100001' */]: {
      keitou?: { [key: number /** 系統ID e.g. 101 */]: string /** 系統の表示名 e.g. "文化・語学・人間" */ }
      photo: string
      prefecture: string /** 都道府県のID e.g. '1' */
      prefectureName: string
      ryokin: string
      schoolDataId: string | null
      schoolName: string
      schoolNo: string /** 学校ID e.g. 'D100001' */
      schoolType: number /** 学校タイプID e.g. 1 */
      schoolTypeName: string /** 学校タイプ e.g. '大学' */
      seikyuuCode: string /** 請求コード e.g. '100001' */
      shiryouType: number /** 資料請求タイプID e.g. 1 */
    }
  }
  resultSummary: {
    count: number
    keitou?: string[] | null
    prefecture?: string[] | null
    schoolType?: string
    searchStr?: string | null
    schoolNo?: string[]
  }
}

export async function search(params?: Params) {
  return client.get<Response>('get_request_search', { params }).then(({ data }) => data)
}
